import { useEffect } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import moment from 'moment-timezone';
import GlobalToast from './components/global-toast';
import { getNotification } from './services/api-helpers/utility';
import Auth from './services/auth';
import { TOGGLE_GLOBAL_TOAST, UPDATE_NOTIFICATIONS } from './store/actions/action-types';
import { useDispatchToProps } from './store/actions/actions';
import store from './store/configure-store';
import { orgIdSelector } from './store/selectors';

function Boot({ children }) {
  const updateNotificationStore = useDispatchToProps(UPDATE_NOTIFICATIONS);
  const toggleToast = useDispatchToProps(TOGGLE_GLOBAL_TOAST);

  const handleGetNotifications = async () => {
    const orgId = orgIdSelector(store.getState());

    if (!orgId) {
      return;
    }
    const userId = Auth().getUserId();
    try {
      const { body, ok } = await getNotification({ userId, orgId, timezone: moment.tz.guess() });
      if (ok) {
        const unreadList = body.data.filter((item) => !item.isRead);
        const currentStore = store.getState();
        if (
          currentStore &&
          currentStore.app.notifications &&
          currentStore.app.notifications.unReadRecords < unreadList.length
        ) {
          toggleToast({
            label: 'You have a new notification(s)',
            visibility: true,
            type: 'info',
          });
        }
        updateNotificationStore({
          list: body.data,
          unreadList,
          loading: false,
          unReadRecords: unreadList.length,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', () => {
      /**
       * We get user notification when user see application
       */
      if (document.visibilityState !== 'visible') {
        return;
      }

      (async () => {
        await handleGetNotifications();
      })();
    });
  }, []);

  return (
    <>
      {children}
      <GlobalToast />
    </>
  );
}

export default Boot;
